module.exports = __webpack_public_path__ + "static/nyoutritious-1_PLACEHOLDER-f6907caa296942ba56e53f2fa9459ca5.jpg";